<template>
    <div>
        <div class="modal" tabindex="-1" role="dialog" v-if="showModal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $t('create') }} {{ $t('user') }}</h5>
                        <button type="button" class="btn-close" @click="closeModal"></button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="createUser">
                            <div class="form-group">
                                <label for="name" class="form-label">{{ $t('username') }} *</label>
                                <input type="text" class="form-control" id="username" v-model="user.username" required>
                            </div>
                            <div class="form-group">
                                <label for="name" class="form-label">{{ $t('name') }} *</label>
                                <input type="text" class="form-control" id="name" v-model="user.name" required>
                            </div>
                            <div class="form-group">
                                <label for="email" class="form-label">{{ $t('email') }} *</label>
                                <input type="email" class="form-control" id="email" v-model="user.email" required>
                            </div>
                            <div class="form-group">
                                <label for="password" class="form-label">{{ $t('password') }} *</label>
                                <div class="input-group">
                                    <input type="text" class="form-control" id="password" v-model="user.password"
                                        :disabled="user.password === ''" aria-describedby="passwordHelpBlock" required>
                                    <button type="button" class="btn btn-secondary" @click="generatePassword">{{
                                        $t('generate_password') }}</button>
                                </div>
                                <div id="passwordHelpBlock" class="form-text">{{ $t('password_help') }}</div>
                            </div>
                            <div class="form-group">
                                <label for="company" class="form-label">{{ $t('company') }}</label>
                                <input type="company" class="form-control" id="company" v-model="user.company">
                            </div>
                            <div class="form-check">
                                <label for="isAdmin" class="form-check-label">{{ $t('is_admin') }}</label>
                                <input type="checkbox" class="form-check-input" id="isAdmin" v-model="user.isAdmin"
                                    aria-describedby="adminHelpBlock">
                            </div>
                            <div id="adminHelpBlock" class="form-text">{{ $t('admin_help') }}</div>
                            <div v-if="message" :class="alertClass">
                                {{ message }}
                            </div>
                            <div class="modal-footer">
                                <button type="submit" class="btn btn-primary">{{ $t('apply') }}</button>
                                <button type="button" class="btn btn-secondary" @click="closeModal">{{ $t('cancel')
                                    }}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const { getCookie } = require('@/helpers');
import axios from 'axios';

export default {
    data() {
        return {
            user: {
                username: '',
                name: '',
                email: '',
                password: '',
                company: '',
                isAdmin: false
            },
            message: '',
            alertClass: ''
        };
    },
    emits: ['close-modal', 'data-updated'],
    props: {
        showModal: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        async createUser() {
            try {
                const token = getCookie('token');
                await axios.post(`${this.$url}/users`,
                    {
                        ...this.user,
                        action: 'create'
                    },
                    {
                        headers: {
                            Authorization: 'Bearer ' + token,
                            ContentType: 'application/json'
                        }
                    });
                // Handle successful response
                this.setMessage(this.$t('user_created'), true);
                this.$emit('data-updated');
                // Close modal after 3 seconds
                setTimeout(() => {
                    this.closeModal();
                }, 3000);
            } catch (error) {
                console.error('Error creating user:', error);
                if (error.response && error.response.data) {
                    this.setMessage(this.$t('error') + ': ' + error.response.data, false);
                } else {
                    this.setMessage(this.$t('error') + ': ' + error.message, false);
                }
            }
        },
        async generatePassword() {
            try {
                const token = getCookie('token');
                const response = await axios.get(`${this.$url}/generate-password`, {
                    headers: {
                        Authorization: 'Bearer ' + token,
                        ContentType: 'application/json'
                    }
                });
                this.user.password = response.data;
            } catch (error) {
                console.error('Error generating password:', error);
                if (error.response && error.response.data) {
                    this.setMessage(this.$t('error') + ': ' + error.response.data, false);
                } else {
                    this.setMessage(this.$t('error') + ': ' + error.message, false);
                }
            }
        },
        closeModal() {
            this.user = {
                username: '',
                name: '',
                email: '',
                password: '',
                company: '',
                isAdmin: false
            };
            this.message = '';
            this.$emit('close-modal');
        },
        setMessage(message, isSuccess) {
            this.message = message;
            this.alertClass = isSuccess ? 'alert alert-success' : 'alert alert-warning';
        }
    }
};
</script>

<style scoped>
.modal {
    display: block;
    /* Ensure modal is displayed */
}
</style>